import React from "react";
import { useRouter } from "next/router";
import { appSelector, appDispatch } from "@/store/hooks";
import { getSession } from "@/features/login";

const withAuth = (WrappedComponent: React.FC) => (props: any) => {
  const [isMounted, setIsMounted] = React.useState(false);
  const router = useRouter();
  const { data, isAuthenticated, isAuthenticating } = appSelector(
    (state: any) => state.login_front,
  );
  const dispatch = appDispatch();

  React.useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) return null;

  const { route } = router;

  if (isAuthenticating) {
    dispatch(getSession());
    return null;
  }

  if (route !== "/login" && route !== "/register") {
    if (!isAuthenticated) {
      router.push(`/login`);
      return null;
    }
  } else {
    if (isAuthenticated) {
      router.push(`/`);
      return null;
    }
  }

  return (
    <WrappedComponent
      {...props}
      user_id={data.data.user_id}
      token={data.data.token}
    />
  );
};

export default withAuth;
